export default __webpack_public_path__ + "static/media/35t.e9afc3c1.jpg";